<template>
  <div class="order-converted-audit">
    <OrderFilterAudit
      :type.sync="type"
      @updateFilter="updateFilter"
    />
    <OrderConvertedDetail
      :type.sync="type"
      :search.sync="search"
    />
  </div>
</template>
<script>
import OrderFilterAudit from '@/components/order/OrderFilterAudit.vue'
import OrderConvertedDetail from '@/components/order/OrderConvertedDetail.vue'
export default {
  name: 'OrderConvertedAudit',
  components: {
    OrderFilterAudit,
    OrderConvertedDetail
  },
  data() {
    return {
      type: 'convertedAudit',
      search: {
        p: 1,
        limit: 10,
        shop_id: '0',
        method: '',
        status: '2,6'
      }
    }
  },
  mounted() {},
  methods: {
    updateFilter(val) {
      this.search = val
    }
  }
}
</script>
<style lang="scss"></style>
